import React, { useState } from 'react';
import './Changelog.css';
import { months } from '../data/changelog';

const TAG_LABEL = { new: 'New', fix: 'Fixed' };

function countByType(month) {
  let newCount = 0;
  let fixCount = 0;
  month.groups.forEach(g => g.items.forEach(item => {
    if (item.type === 'new') newCount += 1;
    else if (item.type === 'fix') fixCount += 1;
  }));
  return { newCount, fixCount, total: month.groups.reduce((n, g) => n + g.items.length, 0) };
}

export default function Changelog({ user }) {
  const [activeMonthId, setActiveMonthId] = useState(months[0].id);
  const activeMonth = months.find(m => m.id === activeMonthId) || months[0];
  const { newCount, fixCount, total } = countByType(activeMonth);

  const overallTotal = months.reduce((n, m) => n + countByType(m).total, 0);
  const overallNew = months.reduce((n, m) => n + countByType(m).newCount, 0);
  const overallFix = months.reduce((n, m) => n + countByType(m).fixCount, 0);

  return (
    <div className="changelog">
      <div className="changelog-header">
        <div className="changelog-header-icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 8v4l3 3"/>
            <circle cx="12" cy="12" r="9"/>
          </svg>
        </div>
        <div>
          <h1 className="changelog-title">What&rsquo;s New</h1>
          <p className="changelog-subtitle">A running record of platform updates, organized by month. Visible to admins and site managers.</p>
        </div>
      </div>

      <div className="changelog-stats">
        <div className="changelog-stat">
          <div className="changelog-stat-num">{overallTotal}</div>
          <div className="changelog-stat-label">total updates</div>
        </div>
        <div className="changelog-stat">
          <div className="changelog-stat-num changelog-stat-num--new">{overallNew}</div>
          <div className="changelog-stat-label">new features</div>
        </div>
        <div className="changelog-stat">
          <div className="changelog-stat-num changelog-stat-num--fix">{overallFix}</div>
          <div className="changelog-stat-label">fixes</div>
        </div>
        <div className="changelog-stat">
          <div className="changelog-stat-num">{months.length}</div>
          <div className="changelog-stat-label">months covered</div>
        </div>
      </div>

      <div className="changelog-body">
        <aside className="changelog-sidebar">
          <nav className="changelog-months">
            {months.map((m, i) => (
              <button
                key={m.id}
                className={`changelog-month-btn${activeMonthId === m.id ? ' active' : ''}`}
                onClick={() => setActiveMonthId(m.id)}
              >
                <span>{m.label}</span>
                {i === 0 && <span className="changelog-latest-badge">Latest</span>}
              </button>
            ))}
          </nav>
        </aside>

        <article className="changelog-content">
          <div className="changelog-content-header">
            <h2 className="changelog-content-title">{activeMonth.label}</h2>
            <div className="changelog-content-counts">
              <span className="changelog-count-chip changelog-count-chip--new">{newCount} new</span>
              <span className="changelog-count-chip changelog-count-chip--fix">{fixCount} fixed</span>
              <span className="changelog-content-count">{total} total</span>
            </div>
          </div>

          {activeMonth.groups.map((group, gi) => (
            <section key={gi} className="changelog-group">
              <h3 className="changelog-group-title">{group.title}</h3>
              <ul className="changelog-items">
                {group.items.map((item, ii) => (
                  <li key={ii} className="changelog-item">
                    {item.type && (
                      <span className={`changelog-tag changelog-tag--${item.type}`}>{TAG_LABEL[item.type]}</span>
                    )}
                    <span className="changelog-item-text">{item.text}</span>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </article>
      </div>
    </div>
  );
}
